import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AuthenticationService } from '../services/authentication.service';
import React, { useEffect, useState } from 'react'
//import HabitacionService from "../services/habitacion.service";
import * as Constants from '../constants';
import { FaEdit } from "react-icons/fa";
import { MdAssignmentAdd } from "react-icons/md";

export default function useColumnsPersonal(togglePop, togglePop2, guardarSelectedUsuario) {
	const authenticationService = new AuthenticationService();
    const userRol = authenticationService.getAuthenticationSession().user.idTipo;//obtiene el rol del usuario
    const userTipoEmpleado = authenticationService.getAuthenticationSession().user.tipoEmpleado;
	
    const [t] = useTranslation("global");

    const onEditarUsuario = (usuario) => {
        guardarSelectedUsuario(usuario);
        togglePop();
    }

	//const [habitacionesAsignadas, setHabitacionesAsignadas] = useState([]);

	/*const cargarHabitacionesAsignadas = async (usuario) => {
		await HabitacionService.getHabitacionesByParams(1, true, null, null, null, usuario)
			.then(response => response.json())
			.then(data => setHabitacionesAsignadas(data))
			.then((response) => {
				if (response.status === 200) {
					return habitacionesAsignadas;
				} else {
					return '';
				}
			});
	}*/
	

    const onAsignarHabitaciones = (usuario) => {
        guardarSelectedUsuario(usuario);
        togglePop2();
    }

    const columns = useMemo(() => {
		const baseColumns = [
			{
                Header: t("app.empleado.table.nombre"),
                Cell: ({ row }) => (
					<div>
						<p className="letra-negro-columna">{row.original.nombre}</p>
					</div>
					)
            },
            {
                Header: t("app.empleado.table.apellidos"),
                Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.apellidos}</p>
					</div>
					)
            },
            
        ];
        
        if (userRol == Constants.ROLE_USUARIO_GESTOR) {
			baseColumns.push(
				{
                	Header: t("app.empleado.table.habasignadas"),
                	Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.habitacionesAsignadas}</p>
					</div>
					)
	            }
	        )
		}
		
		if (userRol == Constants.ROLE_USUARIO_TRABAJADOR) {
			baseColumns.push(
				{
                	Header: t("app.empleado.table.habasignadas"),
                	Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.habitacionesAsignadas}</p>
					</div>
					)
	            }
	        )
		}
        
        if (userRol !== Constants.ROLE_USUARIO_TRABAJADOR) {
			baseColumns.push(
				{
                	Header: t("app.empleado.table.telefono"),
                	Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.telefono}</p>
					</div>
					)
	            },
	            {
	                Header: t("app.empleado.table.mail"),
	                Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.email}</p>
					</div>
					)
	            },
	            {
	                Header: t("app.empleado.table.nif"),
	                Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.nif}</p>
					</div>
					)
	            },
	            {
	                Header: t("app.empleado.table.puesto"),
	                Cell: ({ row }) => (
					<div>
						<p className="letra-grisClaro-columna">{row.original.tipoEmpleado.nombre}</p>
					</div>
					)
	            },
	            {
                	Header: t("app.empleado.table.estado"),
                	Cell: ({ row }) => (
					<div>
						{row.original.activo ?
							<div className="dotTableValueStyle">
								<span className="dotActive"></span><p className="letra-grisClaro-columna">{t("app.popup.label.activo")}</p>
							</div>
							: <div className="dotTableValueStyle">
								<span className="dotInactive"></span><p className="letra-grisClaro-columna">{t("app.popup.label.inactivo")}</p>
							</div>
						}
					</div>
					)
            	}
			);
		}
		
		/*if (userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado != null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) {
			baseColumns.push(
				{
					Header: t("app.empleado.table.habitacionesAsignadas"),
					accessor: row => cargarHabitacionesAsignadas(row.id)
				},
			);
		}*/
		
		baseColumns.push(
			{
                accessor: 'action',
                Cell: ({ row }) => (
                    <div>
                        {(userRol === Constants.ROLE_USUARIO_TRABAJADOR && userTipoEmpleado != null && userTipoEmpleado.id === Constants.TIPO_EMPLEADO_GOBERNANTA) ? (
                            <button className={'button-actionRecord'} onClick={(e) => onAsignarHabitaciones(row.original, e)}><MdAssignmentAdd size='20' className={'icon-button-editarRecord'}/></button>
                        ) : (
							<button className={'button-actionRecord'} onClick={(e) => onEditarUsuario(row.original, e)}><FaEdit size='20' className={'icon-button-editarRecord'}/></button>
                        )}
                    </div>
                ),
            }
		);

        return baseColumns;
    }, [t, userRol]);

    return columns;

}